var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExposure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 0H20.8C22.23 0 23.4 1.2 23.4 2.66667V21.3333C23.4 22.8 22.23 24 20.8 24H2.6C1.17 24 0 22.8 0 21.3333V2.66667C0 1.2 1.17 0 2.6 0ZM2.60058 21.3324H19.5006C20.2156 21.3324 20.8006 20.7324 20.8006 19.999V2.66571L2.60058 21.3324Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExposure);
export default __webpack_public_path__ + "static/media/exposure.e6bf30cb.svg";
export { ForwardRef as ReactComponent };